<ng-container *upuTranslate="let t">
  <upu-side-panel
    [title]="t('notificationPanel.title')"
    [(open)]="openPanel"
    [width]="400"
  >
    <ng-template #header>
      <div class="flex gap-4 items-center justify-between">
        <div class="shrink-0 flex gap-1 w-fit border-2 rounded-xl bg-gray-200">
          @for (tab of tabs; track tab.name) {
            <button
              [id]="tab.name"
              role="tab"
              class="relative min-w-20 h-7 flex items-center justify-center gap-2 rounded-[10px] px-4 text-md font-semibold after:absolute after:inset-0 after:rounded-[10px] after:bg-main after:shadow-sm after:opacity-0 after:transition-opacity transition-colors hover:bg-black/5 focus-visible:outline-primary"
              [class.after:opacity-100]="filterBy() === tab.name"
              (click)="filterBy.set(tab.name)"
            >
              @if (tab.name === 'unread' && unreadCount() > 0) {
                <span
                  class="block rounded-full shrink-0 bg-error text-white font-semibold text-xs min-w-4 min-h-4 leading-4 px-1 relative z-10 animate-fade-in"
                >
                  {{ unreadCount() < 100 ? unreadCount() : '99+' }}
                </span>
              }

              <span class="relative z-10">{{ t(tab.label) }}</span>
            </button>
          }
        </div>

        <button
          id="mark-all-as-read"
          type="button"
          class="shrink w-fit font-medium text-primary text-md p-1 transition-opacity hover:opacity-80 rounded-xl focus-visible:outline-primary"
          [disabled]="loading() || !unreadCount()"
          (click)="markAllAsRead()"
        >
          <div class="flex gap-3 items-center">
            <span>{{ t('notificationPanel.markAllAsRead') }}</span>

            @if (loading()) {
              <mat-spinner
                [diameter]="15"
                class="animate-fade-in current-color-spinner"
              />
            }
          </div>
        </button>
      </div>
    </ng-template>

    @if (!notifications.isLoading()) {
      <section
        class="flex flex-col gap-4 pt-0.5"
        [class.h-full]="!notifications.value().length"
      >
        @for (notification of notifications.value(); track notification.id) {
          <div #viewPortTrigger>
            @defer (on viewport(viewPortTrigger)) {
              <upu-notification-card
                [notification]="notification"
                class="animate-fade-in"
              />
            }
          </div>
        } @empty {
          <upu-no-data-message
            icon="notifications_off"
            [title]="
              filterBy() === 'unread'
                ? 'notificationPanel.noUnreadNotifications.title'
                : 'notificationPanel.noNotifications.title'
            "
            [description]="
              filterBy() === 'unread'
                ? 'notificationPanel.noUnreadNotifications.description'
                : 'notificationPanel.noNotifications.description'
            "
          />
        }
      </section>
    } @else {
      <div class="flex flex-col gap-4 animate-fade-in overflow-hidden">
        @for (item of spinnerSize; track $index) {
          <div class="w-full h-28 bg-gray-200 rounded-2xl animate-pulse"></div>
        }
      </div>
    }
  </upu-side-panel>
</ng-container>
